module.exports = __webpack_public_path__ + "static/media/cabbage-broccoli.d2107ba3.png";